import { createFileRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";

import { AlignmentGap } from "@/components/brand-intel/audience/alignment-gap";
import { ContentPreferences } from "@/components/brand-intel/audience/content-preferences";
import { Demographics } from "@/components/brand-intel/audience/demographics";
import { PlatformAffinity } from "@/components/brand-intel/audience/platform-affinity";
import { PageHeader } from "@/components/layout/heading";

export const Route = createFileRoute("/dashboard/intelligence/_layout/audience")({
  component: Audience,
});

export function Audience() {
  return (
    <section className="w-full space-y-6">
      <PageHeader title={
        <div className="flex items-center gap-2">
          <Users className="size-5 text-muted-foreground" strokeWidth={2.5} />
          Audience Intelligence
        </div>
      } />
      <div className="grid gap-6 grid-cols-1 lg:grid-cols-3">
        <Demographics />
        <PlatformAffinity />
        <ContentPreferences />
      </div>
      <AlignmentGap />
    </section>
  );
}
